module.exports = ".modal-medium-personalized {\n  overflow-x: hidden !important; }\n\n.brd-none {\n  border: none !important; }\n\n.ml-90 {\n  margin-left: 90% !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/shared/radication-docs/radication-docs.component.scss
// module id = ./src/app/forms/shared/radication-docs/radication-docs.component.scss
// module chunks = main